import React from "react";

export const Card = ({ className = "", hover = false, children, ...props }) => (
  <div
    className={`rounded-2xl border border-slate-100 dark:border-ink-800 bg-white dark:bg-ink-900 shadow-[0_2px_8px_rgba(0,0,0,0.04)] transition-all duration-200
      ${hover ? "hover:-translate-y-0.5 hover:shadow-[0_8px_20px_rgba(0,0,0,0.06)]" : ""} ${className}`}
    {...props}
  >
    {children}
  </div>
);

export const CardHeader = ({ className = "", children, ...props }) => (
  <div className={`flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-ink-800 ${className}`} {...props}>
    {children}
  </div>
);

export const CardBody = ({ className = "", children, ...props }) => (
  <div className={`p-6 ${className}`} {...props}>
    {children}
  </div>
);

export default Card;
